import { render, staticRenderFns } from "./autorizacionIndividualModal.vue?vue&type=template&id=77de53be"
import script from "./autorizacionIndividualModal.vue?vue&type=script&lang=js"
export * from "./autorizacionIndividualModal.vue?vue&type=script&lang=js"
import style0 from "./autorizacionIndividualModal.vue?vue&type=style&index=0&id=77de53be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports